<aside class="admin-sidebar" [class.collapsed]="collapsed()" [attr.aria-labelledby]="headingId">
  <div class="sidebar-header">
    <div class="header-content">
      <cm-icon [name]="headerIcon()" class="sidebar-icon" size="md" />
      <h2 class="sidebar-title" [id]="headingId">{{ headerTitle() }}</h2>
    </div>
    <button
      type="button"
      class="collapse-button"
      (click)="toggleCollapsed()"
      [attr.aut-id]="'collapse-button'"
      [attr.aria-label]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [cmTooltip]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.aria-expanded]="!collapsed()"
    >
      <cm-icon [name]="collapsed() ? 'left_panel_open' : 'left_panel_close'" size="md" />
    </button>
  </div>
  <nav neoVerticalNav class="sidebar-nav" role="navigation" [attr.aria-label]="ariaLabel()">
    @for (item of items(); track item.route) {
      <button
        neoVerticalNavItem
        [routerLink]="item.route"
        routerLinkActive="neo-vertical-nav-item-selected"
        [attr.aut-id]="item.testId"
        [attr.title]="collapsed() ? item.label : null"
        [attr.aria-label]="collapsed() ? item.label : null"
        [ariaCurrentWhenActive]="true"
        [disabled]="item.disabled || false"
        (click)="onNavigated()"
      >
        <cm-icon [name]="item.icon" class="neo-nav-icon neo-nav-icon-start" size="md" />
        <span class="neo-nav-text" [attr.aria-hidden]="collapsed() ? 'true' : null">{{ item.label }}</span>
        @if (item.tag) {
          <cm-chip color="info" size="sm" [attr.aria-label]="item.tag + ' (preview feature)'">{{ item.tag }}</cm-chip>
        }
      </button>
    }
  </nav>
</aside>

<div class="sidebar-menu-backdrop" [class.collapsed]="collapsed()"></div>

<div class="sidebar-menu-mobile-header">
  <div class="sidebar-header">
    <button
      type="button"
      class="collapse-button"
      (click)="toggleCollapsed()"
      [attr.aut-id]="'collapse-button'"
      [attr.aria-label]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [cmTooltip]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.aria-expanded]="!collapsed()"
    >
      <cm-icon [name]="collapsed() ? 'left_panel_open' : 'left_panel_close'" size="md" />
    </button>
    <div class="header-content">
      <h2 class="sidebar-title" [id]="headingId">{{ headerTitle() }}</h2>
    </div>
  </div>
</div>